import {ModalProps} from "react-bootstrap/Modal";
import {Modal} from "react-bootstrap";
import React, {memo, useEffect} from "react";
import {useDispatch} from "react-redux";
import {AppDispatch} from "../../store/configureStore";
import {actions} from "../../store/sliceApp";

const ModalError= (props: ModalProps) => {
    const dispatch = useDispatch<AppDispatch>();
    useEffect(() => {
        dispatch(actions.hideLoading())
    },[props.text])
    return (
        <Modal
            {...props}
            size={"sm"}
        //    centered
        >
            <Modal.Header closeButton>
                Ошибка
            </Modal.Header>
            <Modal.Body>
                <p style={{color: "red"}}>
                    {props.text?.message ?  props.text?.message : props.text}
                </p>
            </Modal.Body>
        </Modal>
    );
}

export default memo(ModalError)
